import { render, staticRenderFns } from "./DishItem.vue?vue&type=template&id=cef6acbc&"
import script from "./DishItem.vue?vue&type=script&lang=js&"
export * from "./DishItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DishItem.vue"
export default component.exports